"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPAddressFieldLogic = void 0;
var ip_address_fieldtype_1 = require("./ip-address.fieldtype");
Object.defineProperty(exports, "IPAddressFieldLogic", { enumerable: true, get: function () { return ip_address_fieldtype_1.IPAddressFieldLogic; } });
